/**
 * Le parole della miniatura dell’immagine principale: testo alternativo,
 * prima e dopo nella storia delle versioni, nota del piano editoriale.
 */
import type { DictNode } from './dict.js'

export const mainImageIt: DictNode = {
  mainImage: {
    alt: 'Immagine principale di «{{title}}»',
    none: 'Nessuna immagine',
    before: 'Prima',
    after: 'Dopo',
    changed: 'L’immagine è cambiata: prima e dopo',
    planCurrent: 'Immagine della bozza collegata. La richiesta per l’immagine è nella scheda qui sotto.',
  },
}

export const mainImageEn: DictNode = {
  mainImage: {
    alt: 'Main image of “{{title}}”',
    none: 'No image',
    before: 'Before',
    after: 'After',
    changed: 'The image changed: before and after',
    planCurrent: 'Picture of the linked draft. The request for the image is in the card below.',
  },
}
